module.exports = __webpack_public_path__ + "img/zhengshu1.517be6eb.jpg";